<template lang="pug">
	.network-show--detail.network-show--name-detail.flex-col.space(v-if="item")
		template(v-if="editing")
			EditableLabelField(:caption="$tCaption('Name')", :value.sync="item.Name", type="text", stylingMode="filled", :editingMode="true")
		template(v-else)
			.name {{getLimited(item.Name)}}
</template>

<script>
	import EditableLabelField from 'app-core/EditableLabelField.vue';

	export default {
		translationCategory: 'networkShow.NameDetail',
		name: 'network-show--name-detail',
		props: ['item', 'editing', 'searching', 'linked', 'events'],
		components: {
			EditableLabelField
		},
		data() {
			return {
			};
		},
		mounted() {
			if (__DEBUG__)
				window.nameDetail = this;
		},
		methods: {
			getLimited(txt, limit) {
				const result = this.searching ? (txt || '').substr(0, limit) : txt;
				return result + (result.length < txt?.length ? '..' : '');
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--name-detail {
		.name {
			font-size: 16px;
		}
	}
</style>
